<template>
    <div>
        <el-button type="primary" size="mini" plain @click="getData">
            <span class="el-icon-edit-outline">编辑项目亮点</span>
        </el-button>
        <el-dialog
            title="项目亮点"
            :visible.sync="showdialog"
            width="800px"
            v-dialogDrag
            append-to-body>
            <el-form class="base-form" label-width="80px" :inline="false" size="mini">
                <el-form-item label="项目亮点">
                    <el-input type="textarea" v-model="form.lightsopt" placeholder="这里填写项目亮点"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="confirm">保存</el-button>
                    <el-button @click="showdialog = false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    name: 'ProjectLightspot',
    data() {
        return {
            showdialog: false,
            form: {
                lightsopt: '',
            },
        }
    },
    props: {
        id: {
            type: String,
        },
    },
    mounted () {
        
    },
    methods: {
        getData() {
            this.showdialog = true;
            var params = {
                id: this.id,
            }
            this.$api.getProjectById(params).then(
                data=>{
                    if (data.lightsopt) this.form.lightsopt = data.lightsopt;
                }
            )
        },
        confirm() {
            var params = {
                id: this.id,
                lightsopt: this.form.lightsopt,
            };
            this.$api.editProjectLightsopt(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        }
    },
}
</script>

<style lang="scss" scoped>
.base-form{
    ::v-deep .el-textarea__inner{
        min-height: 300px!important;
    }
}
</style>